import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import config from '../../config';
import './styles.scss';



function Cart(props) {
    const { num } = props;
    return (
        <Link className="right-info" to={`${config.root}/Cartlist` } >
            <i >{num}</i>
        </Link>
    );
}

export default Cart;